import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RvDividerComponent } from 'src/app/components/divider/divider.component';
import { RvSpinnerDirective } from 'src/app/components/loading/rv-spinner.directive';
import { NotificationAlertComponent } from 'src/app/components/notification-alert/notification-alert.component';
import { QuantityComponent } from 'src/app/components/quantity/quantity.component';
import {
  INTERACTIVE_LICENSE_DEFAULT_QUANTITY,
  INTERACTIVE_LICENSE_MIN_QUANTITY,
  PurchaseInteractiveService,
} from '../../services/purchase-interactive.service';
import { PurchaseStepsService } from '../../services/purchase-steps.service';
import { RvButtonComponent } from '../../../components/button/button.component';

@Component({
  selector: 'purchase-interactive-license',
  templateUrl: './purchase-interactive-license.component.html',
  styleUrls: ['./purchase-interactive-license.component.scss'],
  standalone: true,
  imports: [
    RvButtonComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NotificationAlertComponent,
    QuantityComponent,
    RvDividerComponent,
    RvSpinnerDirective,
  ],
})
export class PurchaseInteractiveLicenseComponent implements OnInit, OnDestroy {
  @Input() shown = true;

  readonly quantityMin = INTERACTIVE_LICENSE_MIN_QUANTITY;
  readonly quantityDefault = INTERACTIVE_LICENSE_DEFAULT_QUANTITY;

  addCoupon = false;
  couponCode = '';

  private formSubscriptions: Subscription[] = [];

  constructor(
    public purchaseInteractiveService: PurchaseInteractiveService,
    private purchaseStepsService: PurchaseStepsService,
  ) {}

  ngOnInit(): void {
    this.formSubscriptions.push(
      this.form.controls.quantity.valueChanges.subscribe(() =>
        this.onQuantityChange(),
      ),
    );
  }

  ngOnDestroy(): void {
    this.formSubscriptions.forEach((s) => s.unsubscribe());
  }

  get form() {
    return this.purchaseInteractiveService.form;
  }

  onQuantityChange(): void {
    this.purchaseInteractiveService.onQuantityChanged();
  }

  applyCouponCode(): Promise<void> {
    this.purchaseInteractiveService.couponCode = this.couponCode;
    return this.purchaseInteractiveService.applyCouponCode().then(() => {
      if (!this.purchaseInteractiveService.estimate.estimateError) {
        this.addCoupon = false;
      }
    });
  }

  clearCouponCode(): void {
    this.couponCode = '';
    this.purchaseInteractiveService.clearCouponCode();
    this.addCoupon = false;
  }

  cancel(): void {
    this.purchaseInteractiveService.cancel();
  }

  continue(): void {
    this.purchaseInteractiveService.continue().then((canProceed) => {
      if (canProceed) {
        this.purchaseStepsService.setNextStep();
      }
    });
  }
}
